<template>
	<div class="pcfilework">
		<el-backtop ></el-backtop>
		<headers @ChangeEmit="ChangeEmit" ref="head"></headers>
		<div v-if="fileworkno==1" class="elicenviron" >
			<div class="elicabimgpubu">
				<div class="elicabimgpubu-item" v-for="(item,index) in pcelicenvironcosn" :key="index">
					<img :src="item.image" />
				</div>
			</div>
		</div>
		<div v-if="fileworkno==2" class="happyfile" >
			<div class="happabimgpubu">
				<div class="happabimgpubu-item" v-for="(item,index) in pchappyfilecosn" :key="index">
					<img :src="item.image" />
				</div>
			</div>
		</div>
		<div v-if="fileworkno==3" class="salarywel" v-html="pcsalarywelcosn"></div>
		<div v-if="fileworkno==4" class="developen" v-html="developenconts"></div>
		<footers ref=is_change></footers>
	</div>
</template>

<script>
	import '@/lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
	import headers from '../../common/header.vue'
	import footers from '../../common/footers.vue'
	export default{
		data(){
			return{
				fileworkno:1,
				pcelicenvironcosn:'',
				developenconts:'',
				pchappyfilecosn:'',
				pcsalarywelcosn:'',
			}
		},
		created() {
			window.scrollTo(0,0);
			this.getParams()
			this.pcsalarywel()
			this.pcdevelopen()
			this.pcelicenviron()
			this.pchappyfile()
		},
		components:{
			headers,
			footers
		},
		mounted(){
			document.addEventListener('scroll',this.handleScroll,false)
			this.$once('hook:beforeDestroy', () => {
				document.removeEventListener('scroll', this.handleScroll,false)
			})
		},
		methods:{
			handleScroll () {
				let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop 
				this.$refs.head.scrollTop_change(scrollTop)
			},
			ChangeEmit(){ //子组件传递
				//主动调用子组件
				this.$refs.is_change.get_index_channel_data();
				this.$refs.is_change.pageParam();
				this.pcsalarywel()
				this.pcdevelopen()
				this.pcelicenviron()
				this.pchappyfile()
				this.getParams()
			},
			getParams(){
				this.fileworkno = this.$route.query.e
			},
			pchappyfile(){//快乐生活
				let data={
						mold:'pc',
						
					}
						this.$api.get_people_life(data).then((res) => {
						this.pchappyfilecosn=res.data
				});
			},
			pcelicenviron(){//工作环境
				let data={
						mold:'pc',
						
					}
						this.$api.get_people_around(data).then((res) => {
						this.pcelicenvironcosn=res.data
				});
			},
			pcsalarywel(){//薪资福利
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						
					}
						this.$api.get_people_welfare(data).then((res) => {
						this.pcsalarywelcosn=res.data.content
				});
			},
			pcdevelopen(){//培训发展
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					}
					this.$api.get_people_train(data).then((res) => {
					this.developenconts=res.data.content
				});
			},
		},

	}
</script>

<style>
	body{
		padding: 0;
		margin: 0;
	}
	.pcfilework{
		width: 100%;
		height: 100%;
		background-color: #FAFAFA;
		padding-top: 88px;
	}
	.Mywaterfall {
		
	    display: flex;
	    flex-wrap: wrap;
	}
	.image-content {
	    margin: 5px;
	    flex-grow: 2;
	}
	.Mywaterfall img{
	    display: block;
	    min-width: 100%;
	    height: 500px;
	    object-fit: cover;
	}
	
	.elicabimgpubu{
		margin: 40px;
		column-count: 2;
		column-gap: 40px;
	}
	.elicabimgpubu-item{
		margin-bottom: 40px;
		overflow: hidden;
		border-radius: 20px;
	}
	.elicabimgpubu-item img{
		width: 100%;
		height:100%;
		max-width: 920px;
		transition: all .75s linear;
	}
	.elicabimgpubu-item:hover img{
		cursor: pointer;
		transform: scale(1.02,1.02); 
	}
	.elicenviron{
		padding: 0 240px;
	}
	
	.happyfile{
		padding: 0 240px;
	}
	.happabimgpubu{
		margin: 40px;
		column-count: 2;
		column-gap: 40px;
	}
	.happabimgpubu-item{
		margin-bottom: 40px;
		overflow: hidden;
		border-radius: 20px;
	}
	.happabimgpubu-item img{
		width: 100%;
		height:100%;
		max-width: 920px;
		transition: all .75s linear;
	}
	.happabimgpubu-item:hover img{
		cursor: pointer;
		transform: scale(1.02,1.02); 
	}
	.salarywel{
		font-size: 20px;
		padding: 0 240px;
	}
	.developen{
		font-size: 20px;
		padding: 0 240px;
	}
</style>
